import React, { createContext, useState, useEffect } from "react";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  // Check localStorage on mount to set initial authentication state
  useEffect(() => {
    const user = localStorage.getItem("user_website");
    const member = localStorage.getItem("user");
    if (user || (member && JSON.parse(member)?.userType === "member")) {
      setIsAuthenticated(true);
    }
  }, []);

  return (
    <AuthContext.Provider value={{ isAuthenticated, setIsAuthenticated }}>
      {children}
    </AuthContext.Provider>
  );
};
